import {ActionType as TSActionType, getType} from 'typesafe-actions';
import {immerReducer} from '../reducer';

import * as Actions from './actions';
import * as Types from './types';

export type ActionType = TSActionType<typeof Actions>;

function viewer(draft: Types.StateType, action: ActionType) {
  switch (action.type) {
    case getType(Actions.set): {
      draft.viewer = action.payload.viewer;
      break;
    }
  }
}

export default immerReducer<Types.StateType, ActionType>(viewer, {
  viewer: undefined,
});
